import AboutContent from "../components/AboutContent";
import { useAuth } from "../lib/auth";

export default function AboutPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  return (
    <div className="space-y-6" data-testid="about-page">
      <header>
        <div className="label-caps">Informations</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold mt-1">À propos</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Éditeur du service, version du logiciel et vidéo de présentation.
        </p>
      </header>
      <AboutContent isAdmin={isAdmin} />
    </div>
  );
}
